import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface EventsTypePayload extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_EVENTS_TYPE;
    id: string;
    attributes: {
      data: Array<{
        event_type: string;
        event_count: number;
        scheduled_hours: number;
      }>;
    };
  };
}

export const parseEventsTypePayload = (
  payload: BaseInsightPayload
): EventsTypePayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_EVENTS_TYPE,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      event_type: string;
      event_count: number;
      scheduled_hours: number;
    }>;
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_EVENTS_TYPE,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
